module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/240.8db59c4c.png";